const DARK_THEME_SELECTOR = '@media (forced-colors: none) and (prefers-color-scheme: dark)';
const FORCED_COLORS_SELECTOR = '@media (forced-colors: active)';
const LIGHT_THEME_SELECTOR = '@media (forced-colors: none) and (prefers-color-scheme: light)';
const NOT_FORCED_COLORS_SELECTOR = '@media (forced-colors: none)';

export { DARK_THEME_SELECTOR, FORCED_COLORS_SELECTOR, LIGHT_THEME_SELECTOR, NOT_FORCED_COLORS_SELECTOR };
